export const PopupDynamicFieldView = {
  EDIT_DELETE_OPTIONS_VIEW: 'edit_delete_options_view',
  DEFAULT_VALUES_VIEW: 'default_values_view',
  FIELDS_LIST_VIEW: 'fields_list_view',
  TODAYS_DATE_PLUS_NUMBER: 'todays_date_plus_number',
  RATE_CURRENCY_OPTIONS: 'rate_currency_options',
  STYLE_OPTIONS_VIEW: 'style_options_view',
  HAND_WRITING_SIGNATURE_OPTIONS: 'hand_writing_signature_options',
  NOTARY_OPTIONS_VIEW: 'notary_options_view',
};

export const ReactRenderingContent = {
  DYNAMIC_FIELD: 'dynamicField',
  SIGNATURE: 'helloSignField',
  TEMPLATE_VARIABLE_FIELD: 'templateVariableField',
};

export const SigningTagType = {
  TEXT_FIELD: 'text',
  CHECKBOX: 'check',
  RADIO: 'radio',
  DATE: 'date',
  TEXT_HANDWRITING: 'text-handwriting',
  INITIAL: 'initial',
  SIGNATURE: 'sig',
};

export const PrismWidgetType = {
  DYNAMIC_FIELD: 'dynamic-field',
  SIGNATURE: 'signature',
};

export const SigningSignerType = {
  ALL_BORROWERS: 'allBorrowers',
  BORROWER: 'borrower',
  SIGNER: 'signer',
  LOAN_OFFICER: 'loanOfficer',
  NON_BORROWER_ENTITY: 'nonBorrowerEntity',
  NON_BORROWER: 'nonBorrower',
  ROLE_BASED: 'roleBased',
  COMPANY_AUTHORIZED_SIGNER: 'companyAuthorizedSigner',
  SECURITY_GROUP: 'securityGroup',
  // Signer key of the TPO authorized signer. Spelled without a space and matching
  // TpoFormBundleService.SignerTagKey byte for byte: the PDF text-tag locator reassembles the
  // key from the rendered glyph stream and cannot recover a key containing a space.
  TPO_AUTHORIZED_SIGNER: 'AuthorizedSigner',
};

export const CompanyAuthorizedSignerMode = {
  ANY: 'any',
  SINGLE: 'single',
};

const SigningCapacity = {
  DEFAULT: 'Default',
  BORROWER_AND_TRUSTEE: 'BorrowerAndTrustee',
  TRUSTEE: 'Trustee',
  SETTLOR: 'Settlor',
};

export const signingCapacityOptions = [
  { name: 'Default', value: SigningCapacity.DEFAULT },
  { name: 'Borrower and Trustee', value: SigningCapacity.BORROWER_AND_TRUSTEE },
  { name: 'Trustee', value: SigningCapacity.TRUSTEE },
  { name: 'Settlor', value: SigningCapacity.SETTLOR },
];

export const signingSignerTypeOptions = [
  {
    name: 'All Borrowers',
    value: SigningSignerType.ALL_BORROWERS,
  },
  {
    name: 'Role-Based',
    value: SigningSignerType.ROLE_BASED,
  },
  {
    name: 'Borrower 1',
    value: `${SigningSignerType.SIGNER}1`,
  },
  {
    name: 'Borrower 2',
    value: `${SigningSignerType.SIGNER}2`,
  },
  {
    name: 'Borrower 3',
    value: `${SigningSignerType.SIGNER}3`,
  },
  {
    name: 'Borrower 4',
    value: `${SigningSignerType.SIGNER}4`,
  },
  {
    name: 'Non-Borrower Entity 1',
    value: `${SigningSignerType.NON_BORROWER}1`,
  },
  {
    name: 'Non-Borrower Entity 2',
    value: `${SigningSignerType.NON_BORROWER}2`,
  },
  {
    name: 'Non-Borrower Entity 3',
    value: `${SigningSignerType.NON_BORROWER}3`,
  },
  {
    name: 'Non-Borrower Entity 4',
    value: `${SigningSignerType.NON_BORROWER}4`,
  },
];

// Scope-qualified to match its siblings: this slot is only ever offered on a broker-scoped form, where it means
// the PARENT LENDER's signer and sits directly beside the broker's own. Unqualified, the two read alike.
export const signingCompanyAuthorizedSignerTypeOption = {
  name: 'Authorized Signer (parent company)',
  value: SigningSignerType.COMPANY_AUTHORIZED_SIGNER,
};

export const signingSecurityGroupSignerTypeOption = {
  name: 'Security Group (parent company)',
  value: SigningSignerType.SECURITY_GROUP,
};

export const signingTpoAuthorizedSignerTypeOption = {
  name: 'Authorized Signer (broker)',
  value: SigningSignerType.TPO_AUTHORIZED_SIGNER,
};

export const signingLoanOfficerSignerTypeOption = {
  name: 'Loan Officer',
  value: SigningSignerType.LOAN_OFFICER,
};

export const signingTagsOptions = [
  {
    name: 'Text field',
    value: SigningTagType.TEXT_FIELD,
  },
  {
    name: 'Checkbox field',
    value: SigningTagType.CHECKBOX,
  },
  {
    name: 'Date field',
    value: SigningTagType.DATE,
  },
  // Uncomment "Initials Handwriting" in case if it will be needed
  //
  // {
  //   name: 'Initials Handwriting',
  //   value: SigningTagType.TEXT_HANDWRITING,
  //   required: true,
  // },
  {
    name: 'Initials field',
    value: SigningTagType.INITIAL,
    required: true,
  },
  {
    name: 'Signature field',
    value: SigningTagType.SIGNATURE,
    required: true,
  },
];

const SelectionRequirementType = {
  AT_LEAST_ONE: 'AtLeastOne',
  ONLY_ONE: 'OnlyOne',
};

export const selectionRequirementOptions = [
  {
    name: 'At least one selection is required',
    value: 'atleastone',
    altValue: SelectionRequirementType.AT_LEAST_ONE,
  },
  {
    name: 'Only one selection can be made',
    value: 'onlyone',
    altValue: SelectionRequirementType.ONLY_ONE,
  },
];

export const FormBuilderMethodType = {
  DELETE_REACT_COMPONENT: 'deleteReactComponent',
  INSERT_REACT_COMPONENT: 'insertReactComponent',
  INSERT_MULTIPLE_OPTIONS: 'insertMultipleReactComponent',
  DELETE_MULTIPLE_OPTIONS: 'deleteMultipleReactComponent',
};

export const FormBuilderOperationType = {
  UNDO: 'undo',
  REDO: 'redo',
};
